<style scoped lang="less">
@import "modal.less";

.modal-item {
  .modal-item-base();
}

</style>

<template>
  <!-- 切换手机验证 - 开始 -->
  <SafeVerifyModal v-model="modalVis.switchPhone" :smstype="smstype" @on-ok="switchPhoneVerifyHandle"
                   @on-cancel="cancelHandle">
    <div v-if="!whetherVerify.phoneVerifyFlag">
      <Alert type="warning" show-icon>{{ $t('关闭手机验证后') }}24小时内禁止提币</Alert>
    </div>
  </SafeVerifyModal>
  <!-- 切换手机验证 - 结束 -->
</template>

<script>
import SafeVerifyModal from '@/views/personal/Modal/SafeVerifyModal'
import { ajaxTry } from '@/utils'
import { ajax_switchSafeVerify } from '@/api/personal'

export default {
  name: 'SwitchPhoneModal',
  data () {
    return {
      smstype: 9 // 开启手机验证9 关闭手机验证10
    }
  },
  inject: {
    modalVis: 'modalVis',
    whetherVerify: 'whetherVerify'
  },
  computed: {
    phoneVerifyStatus () {
      return this.whetherVerify.phoneVerifyFlag ? 1 : 0
    }
  },
  methods: {
    async switchPhoneVerifyHandle (code) { // 开关手机验证

      let ajaxParam = {
        type: 0,
        status: this.phoneVerifyStatus,
        smsCode: code.phone,
        emailCode: code.email,
        googleCode: code.google
      }
      let [flag] = await ajaxTry(ajax_switchSafeVerify(ajaxParam))
      if (flag) this.modalVis.switchPhone = false

    },
    cancelHandle () {
      // 点击取消还原状态
      this.whetherVerify.phoneVerifyFlag = !this.whetherVerify.phoneVerifyFlag
    }
  },
  components: {
    SafeVerifyModal
  }
}
</script>
